/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  location: Object,
  form: TypeForm,
  accountId: string,
|} & TranslatorProps;

@translate()
@inject('accountStore', 'actionDrawerStore')
@observer
export default class StartAuditForm extends React.Component<*> {
  /**
   * Render location type block
   * @returns {*}
   */
  renderLocationTypeBlock(): React.Node {
    const { t, location, form }: TypeProps = this.props;
    const status = '<i><b>Unaudited</b></i>';

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('actionDrawer:Confirm asset audit by locations')}
          >
            <div className={styles['action-drawer-block-row']}>
              <b>{t('actionDrawer:for')}</b>
            </div>
            <div className={styles['action-drawer-block-row']}>
              <b>{location.name}</b>
            </div>
            <div
              className={styles['action-drawer-block-row']}
              dangerouslySetInnerHTML={{
                __html: t(
                  `actionDrawer:The audit status of all assets for this location will be reset to ${status} when you start the asset audit.`
                ),
              }}
            />
            <div className={styles['action-drawer-block-row']}>
              {t('actionDrawer:Are you sure you wish to continue?')}
            </div>
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('actionDrawer:Start Audit')} />
      </React.Fragment>
    );
  }

  /**
   * Render user type block
   * @returns {*}
   */
  renderUserTypeBlock(): React.Node {
    const { t, user, form }: TypeProps = this.props;
    const status = '<i><b>Unaudited</b></i>';

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('actionDrawer:Confirm asset audit by users')}
          >
            <div className={styles['action-drawer-block-row']}>
              <b>{t('actionDrawer:for')}</b>
            </div>
            <div className={styles['action-drawer-block-row']}>
              <b>{user.name}</b>
            </div>
            <div
              className={styles['action-drawer-block-row']}
              dangerouslySetInnerHTML={{
                __html: t(
                  `actionDrawer:The audit status of all assets for this user will be reset to ${status} when you start the asset audit.`
                ),
              }}
            />
            <div className={styles['action-drawer-block-row']}>
              {t('actionDrawer:Are you sure you wish to continue?')}
            </div>
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('actionDrawer:Start Audit')} />
      </React.Fragment>
    );
  }

  /**
   * Render no type available
   * @returns {*}
   */
  renderError(): React.Node {
    const { t, location, actionDrawerStore }: TypeProps = this.props;
    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock divider={false} gutters={true} heading={t('actionDrawer:Warning')}>
            {t('actionDrawer:No assets assigned at ')}
            <b>{location.name}</b>
          </ActionDrawerBlock>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button variant="contained" onClick={() => actionDrawerStore.closeActionDrawer()}>
            {t('general:Cancel')}
          </Button>
        </div>
      </React.Fragment>
    );
  }

  /**
   * Render
   * @returns {number|*|boolean|string|React$Element<*>|React$Portal|Iterable|null}
   */
  render(): React.Node {
    const { location, type }: TypeProps = this.props;
    const isLocationType =
      type === 'locations' && location && (location.assets_count || location.all_assets_count);
    const isUserType = type === 'users';

    if (isLocationType) {
      return this.renderLocationTypeBlock();
    } else if (isUserType) {
      return this.renderUserTypeBlock();
    }

    return this.renderError();
  }
}
